





















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BaseVue from "../../core/BaseVue";
import * as Quill from "quill";
import * as quillBetterTable from "quill-better-table";

@Component({})
export default class QuillEditor extends BaseVue {
  @Prop({ default: "editor" }) editorId: string;
  @Prop({default: 0}) wordLimit: number;
  @Prop({default: false}) limitLength: boolean;
  @Prop({}) data: string;
  quill: any = null;
  counter: number = 0;
  characters: number = 0;

  mounted() {
    var self = this;

    Quill.register({ "modules/better-table": quillBetterTable }, true);
    
    let toolbarOptions = [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["link", "image", "video", "formula"],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["clean"]
    ];
    this.quill = new Quill(`#${this.editorId}`, {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions,
        table: true,
        "better-table": {
          operationMenu: {
            items: {
              unmergeCells: {
                text: "Another unmerge cells name"
              }
            },
            color: {
              colors: ["green", "red", "yellow", "blue", "white"],
              text: "Background Colors:"
            }
          }
        },
        keyboard: {
          bindings: quillBetterTable.keyboardBindings
        }
      }
    });
    
    this.quill.on('text-change', function() {
      let content = self.quill.getText();
      self.characters = content.length;
      self.counter =  content.split(/\s+/).length - 1;
      if (self.limitLength && self.counter > self.wordLimit) {
        self.quill.deleteText(0, self.characters);
        let text250 = content.split(' ').slice(0, self.wordLimit);
        text250.push(' ');
        self.quill.insertText(0, text250.join(' '));
      }
      self.$emit("updateContent", {data: self.quill.root.innerHTML, length: self.quill.getText().trim().length});
    });
  }

  getQuillContent() {
    this.$emit("updateContent", {data: this.quill.root.innerHTML, length: this.quill.getText().trim().length});
  }

  addTable() {
    let tableModule = this.quill.getModule("better-table");
    tableModule.insertTable(3, 3);
  }

  @Watch("data")
  onDataLoad(oldValue, newValue) {
    if (this.data && this.data != "") {
      this.quill.root.innerHTML = this.data;
    }
  }
}
